import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import React from 'react';
// import { useTranslation } from 'react-i18next';
import { monthNames } from 'src/utils/date';
const ComparisonTable = _ref => {
  var _comparison$allocatio;
  let comparison = _ref.comparison;
  // const { t } = useTranslation();

  const getDate = date => date ? moment(date).format('MM/DD/YYYY') : 'No date';
  const getDateDiff = (date1, date2) => !date1 || !date2 ? '-' : moment(date1).diff(moment(date2), 'days') + 1;
  const getCurrencyValue = value => value ? "$".concat(value.toFixed(2)) : '-';
  return /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Allocated in"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Service days"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Active units"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Occupants"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Bill total"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "CAD"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "GWD"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Allocated total"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Total billed to resident"))), /*#__PURE__*/React.createElement(TableBody, null, comparison === null || comparison === void 0 || (_comparison$allocatio = comparison.allocations) === null || _comparison$allocatio === void 0 ? void 0 : _comparison$allocatio.map(a => {
    var _monthNames;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: a.billId
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, (_monthNames = monthNames[a.month - 1]) === null || _monthNames === void 0 ? void 0 : _monthNames.substring(0, 3), " ", a.year), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, getDateDiff(a.serviceEndDateOnly, a.serviceStartDateOnly), " (", getDate(a.serviceStartDateOnly), "-", getDate(a.serviceEndDateOnly), ")"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, a.activeUnits), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, a.totalOccupants), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, getCurrencyValue(a.billValue)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, a.commonAreaDeduction, "%"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, a.goodwillDeduction, "%"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "$", a.allocatedTotal.toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "$", a.totalBilledToResident.toFixed(2)));
  }))));
};
export default ComparisonTable;